import http from '@/utils/http'

const createAppointment = ({ userId, adminId, callAt }) => http()
  .post(`/phone_services`, {
    user_id: userId,
    admin_id: adminId,
    call_at: callAt
  })

const hangup = ({ id }) => http()
  .post('/phone_services/hangup', { purchase_id: id })

const record = ({ id }) => http()
  .post(`/phone_services/${id}/audio_file`)

const durationForInProgressCall = (purchase, currentTime) => {
  const filter = (states, state) => (states || [])
    .filter(s => s.state === state)
    .map(s => s.created_at)

  const call = purchase.service.call

  const startsAt = [
    ...filter(call.callee_states, 'in-progress'),
    ...filter(call.caller_states, 'in-progress')
  ].sort()[0] || [
      ...filter(call.callee_states, 'ringing'),
      ...filter(call.caller_states, 'ringing')
    ].sort()[0] || purchase.service.call_at
  const endsAt = [
    ...filter(call.callee_states, 'completed'),
    ...filter(call.caller_states, 'completed')
  ].sort()[0]

  const starts = startsAt ? new Date(startsAt) : currentTime
  const defaultEnd = Math.min(+currentTime, (+starts) + call.time_limit * 1000)
  const ends = endsAt ? new Date(endsAt) : new Date(defaultEnd)

  const duration = Math.max(0, (+ends) - (+starts))
  return duration / 1000
}

const duration = purchase => {
  if (purchase.offer.service_type !== 'phone') { return 0 }
  const call = purchase.service.call
  if (!call || !call.duration) { return 0 }
  let duration = call.duration
  if (duration > call.time_limit) { duration = call.time_limit }
  return duration
}

export default {
  hangup,
  record,
  createAppointment,
  duration,
  durationForInProgressCall
}



// WEBPACK FOOTER //
// ./src/api/call.js